// https://dev.to/alfredosalzillo/the-react-context-hell-7p4
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MultiProvider", {
    enumerable: true,
    get: ()=>MultiProvider
});
const _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const nest = (children, component)=>/*#__PURE__*/ _react.default.cloneElement(component, {}, children);
const MultiProvider = ({ children , providers  })=>/*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, providers.reduceRight(nest, children));
